import { React, useRef, useState, useEffect } from 'react';
import './SecurityEducation.css';
import { GiBoatFishing } from "react-icons/gi";
import { IoEarthSharp } from "react-icons/io5";
import { FaBoxOpen, FaClipboardCheck, FaFilm   } from "react-icons/fa";
import { RiPresentationFill } from "react-icons/ri";
import { collection, query, where, orderBy, onSnapshot, addDoc, serverTimestamp, doc, getDocs, getDoc, setDoc, updateDoc, arrayUnion} from 'firebase/firestore';
import { db, auth } from '../../Firebase_Config/firebase';
import { Swiper, SwiperSlide } from 'swiper/react';
import { NavLink } from "react-router-dom";


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';



const toolsData = {
  exercise: {
    title: 'Exercise in a Box',
    content: [
     ` 
        <p>With Exercise in a Box, users can be guided through cybersecurity drills that cover all aspects of planning, setup, and delivery for their organization.</p>
        <p>Additionally, the platform offers a post-activity report feature that enables users to capture any discoveries made during the exercise and utilize these insights to implement meaningful changes to their cybersecurity measures. The platform is provided by the Australian Cyber Security Centre (ACSC).</p>
     `,
    ],
    link: 'https://www.cyber.gov.au/resources-business-and-government/exercise-in-a-box',
    accentClass: 'card-accent alt'
  },
  curricula: {
    title: 'Curricula (Now under the Huntress Brand)',
    content: [
      `
        <p>Curricula is a free security awareness training platform designed to help your organization build a security culture and achieve SOC 2 compliance, at no cost. It’s free for up to 1,000 employees — no credit card required.</p>
        <p>Curricula uses story-based learning to narrate short adventures about cyber security. Employees will enter a world of heroes, villains, and stories all designed to educate employees about cyber threats and how to defend against them.</p>
        <p>What’s Included with Curricula?</p>
        <ul>
          <li>Fun Training Library – Explore a growing curated episode library of content, each 6-8 minutes long, covering topics such as ransomware, passwords, phishing, privacy, and much more.</li>
          <li>Phishing Simulations – Gamify the learning experience using our fun character, DeeDee, to send simulated phishing tests. Employees can be rewarded for reporting phishing tests inside Curricula.</li>
          <li>Automated Syncing – Connect to your email provider or directory service to automatically sync employees. Automatic notifications remind employees to complete their required training.</li>
          <li>Create Custom Content – Quickly build and launch your own custom training content using Curricula’s simple built-in Creator tool. Add quizzes, upload videos, all without needing a designer.</li>
          <li>Simple Plans – When you’re ready to level up your program with more training content, phishing tools, and personalization options, you can upgrade your plan right from the Curricula app.</li>
          <li>Compliance Reporting – Document and showcase your training program results with reports. Employee compliance certificates can be exported as compliance evidence for your audits.</li>
        </ul>
      `
      
    ],
    link: 'https://www.huntress.com/platform/security-awareness-training',
    accentClass: 'card-accent'
  },
  globalcyber: {
    title: 'Global Cyber Alliance Learning Portal',
    content: [
     `
        <p>Cybersecurity for Small Business.</p>
        <p>Access a growing library of free detailed training courses and helpful guided resources for small businesses.</p>
     `
    ],
    link: 'https://edu.globalcyberalliance.org/bundles/small-business',
    accentClass: 'card-accent alt2'
  },
  bingo: {
    title: 'Phishing bingo',
    content: [
     `
       <p>Cybersecurity education doesn’t have to be dull and complicated. Here’s a fun, simple option suitable for every member of a small organization. The Canadian government provides a bingo card that showcases some of the most commonly used phishing tactics, enabling users to familiarize themselves with the telltale signs of phishing.</p> 
     `
    ],
    link: 'https://www.getcybersafe.gc.ca/en/resources/get-cyber-safe-phishing-bingo',
    accentClass: 'card-accent alt3'
  },
  PP: {
    title: 'Training PowerPoint',
    content: [
      
    ],
    accentClass: 'card-accent'
  },
  VideoComments: {
    title: 'Training PowerPoint',
    content: [
      
    ],
    accentClass: 'card-accent'
  }
  
};



const SecurityEducation = () => {
  const getUserId = () => {
    const user = auth.currentUser;
    return user.uid;
  };
  
  const CommentsSection = () => {
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState([]);
    const [userName, setUserName] = useState("");
  
    useEffect(() => {
  
      const fetchSectorNameAndScores = async () => {
              try {
                  const userId = getUserId();
                  console.log('User ID:', userId); // Add this line for debugging     
                  const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
                  const userDocSnapshot = await getDocs(userDocQuery);     
                  if (!userDocSnapshot.empty) {                      
                      const userDocData = userDocSnapshot.docs[0].data();                  
                      const UserName =userDocData.UserName ||0;
                      setUserName(UserName)                        
                  } else {
                      console.log('User document not found for user ID:', userId);
                  }                  
                    } catch (error) {
                        console.error('Error fetching document:', error);
                    }
          };      
          fetchSectorNameAndScores();

          const commentsDocRef = doc(db, "comments", "mainThread");

          const unsubscribe = onSnapshot(commentsDocRef, (docSnap) => {
            if (docSnap.exists()) {
              const data = docSnap.data();
              setComments(data.messages || []);
            } else {
              // If the document doesn't exist yet, create it
              setDoc(commentsDocRef, { messages: [] });
            }
          });
  
      return () => unsubscribe();
    }, []);
  
    const handlePostComment = async () => {
      const trimmed = comment.trim();
      if (!trimmed) return;
  
      const user = auth.currentUser;
      if (!user) return;
  
      const newComment = {
        text: trimmed,
        author: userName,
        uid: user.uid,
        timestamp: new Date().toISOString(),
      };
  
      const commentsDocRef = doc(db, "comments", "mainThread");
  
      try {
        await updateDoc(commentsDocRef, {
          messages: arrayUnion(newComment),
        });
        setComment("");
      } catch (error) {
        console.error("Error posting comment:", error);
      }
    };
  
    return (
      <div style={{  margin: "auto" }}>
        <h2>Comments</h2>
        <div>
          <input
                  className="form_input"
                  type="text"
                  id="comment"
                  name="comment"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Add a comment..."
                />
          <button className='full-width-button' onClick={handlePostComment} >
            Comment
          </button>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          {comments
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            .map((c, index) => (
              <div
                key={index}
                style={{ borderBottom: "1px solid #ccc", padding: "1rem 0" }}
              >
                <strong>{c.author}</strong>
                <p>{c.text}</p>
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  {new Date(c.timestamp).toLocaleString()}
                </div>
              </div>
            ))}
        </div>
        {/*<textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          placeholder="Leave a comment..."
          style={{ width: "100%", padding: "0.5rem" }}
        />*/}
       
      </div>
    );
  };
  
  
  
  
  const [selectedTool, setSelectedTool] = useState('curricula');
   const RenderCard = () => {
    const tool = toolsData[selectedTool];
    const progressCircle = useRef(null);
    const progressContent = useRef(null);
    const onAutoplayTimeLeft = (s, time, progress) => {
      progressCircle.current.style.setProperty('--progress', 1 - progress);
      progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
    };
    const slideImages = Array.from({ length: 47 }, (_, i) => `slide${i + 1}.png`);



    if (selectedTool === 'PP') {
      return (
        <div className='Network-card'>
          <div className={tool.accentClass} />
          <div className="Netprofessional-card">
            <div className="card-body">
              <h2 className="card-title">{tool.title}</h2>
              <p>This training PowerPoint presentation covers essential cybersecurity awareness topics for your team.</p>
              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                pagination={{
                  type: 'fraction',
                }}
                navigation={true}
                loop={true}
                onAutoplayTimeLeft={onAutoplayTimeLeft}
                modules={[Autoplay, Pagination, Navigation,]}
                className="trainPP"
              >
                {slideImages.map((img, index) => (
                  <SwiperSlide key={index}>
                    <img src={`/slides/${img}`} alt={`Slide ${index + 1}`} />
                  </SwiperSlide>
                ))}
                <div className="autoplay-progress" slot="container-end">
                  <svg viewBox="0 0 48 48" ref={progressCircle}>
                    <circle cx="24" cy="24" r="20"></circle>
                  </svg>
                  <span ref={progressContent}></span>
                </div>
              </Swiper>
            </div>
          </div>
        </div>
      );
    }

    if (selectedTool === 'VideoComments') {
      return (
        <div className='Network-card'>
          <div className={tool.accentClass} />
          <div className="Netprofessional-card">
            <div className="card-body">
              <h2 className="card-title">Introduction to Cyber Security</h2>
              <div className='trainPP'>
                <video autoPlay controls>
                <source src="/TrainingVideo.mp4" type="video/mp4"/>
              </video>
              </div>
              
              <CommentsSection/>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className='Network-card'>
        <div className={tool.accentClass} />
        <div className="Netprofessional-card">
          <div className="card-body">
            <h2 className="card-title">{tool.title}</h2>
              <div dangerouslySetInnerHTML={{ __html: tool.content }} ></div>
              {tool.link && (
                <a href={tool.link} target="_blank" rel="noopener noreferrer" className="full-width-button">
                  {tool.title}
                </a>
              )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='supportBG'>
      <div className='InternetContent'>
        <div className='bannerBG'>
          <img src="../Banner.png" alt="banner2" className='banner-image' />
        </div>
        <h1 className='helptitle bigger'>Education & Training</h1>
        <div className='networkGrid'>
          <div className='EduGrid2'>
            {/*<button className="navButtons" onClick={() => setSelectedTool('PP')}>
              <div>
                <RiPresentationFill className="helpicons" />
              </div>
              <span>Training Powerpoint</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('VideoComments')}>
              <div>
                <FaFilm className="helpicons" />
              </div>
              <span>Introduction to Cyber Security</span>
            </button>
            */}
            <NavLink to="/Support/SecurityEducation/Videos" >
              <button className="navButtons">
                <div>
                  <FaFilm className="helpicons" />
                </div>
                <span>Introduction to Cyber Security</span>
              </button>
            </NavLink>
            
            <button className="navButtons" onClick={() => setSelectedTool('curricula')}>
              <div>
                <FaClipboardCheck className="helpicons" />
              </div>
              <span>Curricula</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('exercise')}>
              <div>
                <FaBoxOpen className="helpicons" />
              </div>
              <span>Exercise in a Box</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('globalcyber')}>
              <div>
                <IoEarthSharp  className="helpicons" />
              </div>
              <span>Global Cyber Alliance Learning Portal</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('bingo')}>
              <div>
                <GiBoatFishing  className="helpicons" />
              </div>
              <span>Phishing bingo</span>
            </button>
          </div>      
        </div>
        <br/>
        <div className="help-hrLine" />
        <br/>
        {RenderCard()}
      </div>
    </div>
  );
};

export default SecurityEducation;
